import CommunicationTableContainer from './CommunicationTableContainer';

export default CommunicationTableContainer;